// extracted by mini-css-extract-plugin
export var dividerLine = "_9x-3";
export var itemImage = "_9x-9";
export var lightDivider = "_9x-4";
export var modalContent = "_9x-5";
export var modalContentCompact = "_9x-6";
export var productCard = "_9x-a";
export var productImage = "_9x-b";
export var productImageCompact = "_9x-7";
export var productImagePlaceholder = "_9x-c";
export var productImagePlaceholderCompact = "_9x-8";
export var progressBarBackground = "_9x-1";
export var progressBarContainer = "_9x-0";
export var progressBarFill = "_9x-2";